import { onProductTemplateActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ProductTemplateActivityCard } from "./ProductTemplateActivityCard";

interface Props {
  productTemplateId: number
  config: server.dto.ActivityPanelConfig
}

export const ProductTemplateActivityPanel = (props: Props) => {
  return <ActivityPanel<server.dto.ProductTemplateActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ProductTemplates.ListActivity({ itemId: props.productTemplateId, page, perPage })}
    renderActivity={(activity => <ProductTemplateActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onProductTemplateActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.productTemplateId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}